import { Routes } from '@angular/router';

import { routes as authRoutes } from '@routes/auth.routes';
import { routes as privateRoutes } from '@routes/private.routes';

export const routes: Routes = [
  { path: '', redirectTo: 'a/dashboard', pathMatch: 'full' },
  ...authRoutes,
  ...privateRoutes,
  { path: '**', redirectTo: 'a/dashboard' },
];
